import React from 'react';
import './faq.css';

interface FaqProps {
    t: (key: string) => string;
}

const Faq: React.FC<FaqProps> = ({t}) => {

    return (
        <div className="faq__main_wrapper">
            <div className="faq__inner_wrapper">

                <div className="faq__headline">
                    {t('tab_faq_headline')}
                </div>

                <div dangerouslySetInnerHTML={{ __html: t('tab_faq_paragraph') }} />

            </div>
        </div>
    )

}

export default Faq;
